import { BriefType } from "../../constants/types";
import {
  CLEAR_EXECUTION_BRIEF_ERRORS,
  LOADING_EXECUTION_BRIEFS,
  SUCCESS_RENAME_EXECUTION_PAGE,
  FAILURE_UPDATE_EXECUTION_PAGE,
} from "./executionBriefListActions";
import {
  CLEAR_WORK_ORDER_ERRORS,
  LOADING_WORK_ORDERS,
  SUCCESS_RENAME_WORK_ORDER_PAGE,
  FAILURE_UPDATE_WORK_ORDER_PAGE,
} from "./workOrderActions";
import backend from "../../services/axios.functions";
import { errorMessage, successMessage } from "./messagesActions";
import { PAGES } from "../../features/navigation/types/pages.constant";
import { handleError, createError } from "./errorHandlingAction";

export const updateBriefName = ({
  id,
  newBriefName,
  briefTemplate,
  briefType,
}: {
  id: number;
  newBriefName: string;
  briefTemplate: string;
  briefType: BriefType;
}) => async (dispatch: any) => {
  switch (briefType) {
    case BriefType.EXECUTION_BRIEF:
      dispatch({ type: LOADING_EXECUTION_BRIEFS });
      break;
    case BriefType.WORK_ORDER:
      dispatch({ type: LOADING_WORK_ORDERS });
  }

  const apiUrl = (briefType: BriefType) => {
    switch (briefType) {
      case BriefType.EXECUTION_BRIEF:
        return "/execution-briefs";
      case BriefType.WORK_ORDER:
        return PAGES.WORK_ORDERS_LIST.URL;
    }
  };

  const params = { name: newBriefName };
  try {
    const { data } = await backend.patch(`${apiUrl(briefType)}/${id}/change-name/`, params);
    if (!data) {
      throw new Error("No data in network response");
    }
    switch (briefType) {
      case BriefType.EXECUTION_BRIEF:
        dispatch({ type: CLEAR_EXECUTION_BRIEF_ERRORS });
        dispatch({ type: SUCCESS_RENAME_EXECUTION_PAGE, payload: { ...data } });
        break;
      case BriefType.WORK_ORDER:
        dispatch({ type: CLEAR_WORK_ORDER_ERRORS });
        dispatch({ type: SUCCESS_RENAME_WORK_ORDER_PAGE, payload: { ...data } });
    }
    dispatch(successMessage("Successfully updated name."));
  } catch (error) {
    switch (briefType) {
      case BriefType.EXECUTION_BRIEF:
        handleError(error, dispatch, FAILURE_UPDATE_EXECUTION_PAGE);
        break;
      case BriefType.WORK_ORDER:
        handleError(error, dispatch, FAILURE_UPDATE_WORK_ORDER_PAGE);
    }

    dispatch(errorMessage(createError(error).errorMessage));
  }
};
